import { render, staticRenderFns } from "./section14.vue?vue&type=template&id=317f7c85"
import script from "./section14.vue?vue&type=script&lang=js"
export * from "./section14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports